<ng-container *notInProductCode="[productCode.Premium]">
  <div class="mvp-banner rounded">
    <img class="mvp-banner-bg d-lg-none" alt="" [src]="'banners/mobile.jpg' | contentAssetImage" />
    <img class="mvp-banner-bg d-none d-lg-block" alt="" [src]="'banners/desktop.jpg' | contentAssetImage" />
    <div class="mvp-banner-body">
      <div class="mvp-banner-logo">
        <img alt="" [src]="'logos/logowhite.png' | contentAssetImage" />
      </div>
      <div class="mvp-banner-content text-center text-lg-start">
        <h3 class="mvp-banner-title text-white text-uppercase font-page-heading mb-0">
          {{ 'home.page.mvp.banner.title' | translate: { fgbdefault: 'MVP Membership' } }}
        </h3>
        <p class="mvp-banner-desc text-white mb-0">
          {{
            'home.page.mvp.banner.description'
              | translate
                : {
                    fgbdefault:
                      'Upgrade your membership to MVP and receive welcome package, vendor discounts, game pass to watch NFL games in the UK, priority ticket access and much more.',
                  }
          }}
        </p>
      </div>
    </div>
    <a class="mvp-banner-cta rounded font-heading" [routerLink]="['/membership']">
      {{ 'membership.upgrade.banner.cta' | translate: { fgbdefault: 'Upgrade Now' } }}
    </a>
  </div>
</ng-container>
